<template>
  <div class="customer-wrapper px-5 lg:px-10">
    <slot />
  </div>
</template>
